import React, { useState } from 'react';
import clsx from 'clsx';

interface PasswordInputProps {
	value: string;
	onChange: (value: string) => void;
	error?: string;
	placeholder?: string;
	disabled?: boolean;
	stretch?: boolean;
}

export const PasswordInput = ({
	value,
	onChange,
	error,
	placeholder = 'Password',
	disabled = false,
	stretch = false,
}: PasswordInputProps) => {
	const hasValue = value.length > 0;
	return (
		<div className={clsx(
			'flex flex-col items-start gap-2 self-stretch border-2 border-transparent',
			hasValue ? 'justify-center' : 'rounded-sm focus-within:border-component-input-border-focused',
			stretch && 'self-stretch',
		)}>
			<div className={clsx(
				'flex h-10 pl-3 pr-4 items-center self-stretch',
				'rounded-sm border bg-bg-static-surface_default',
				hasValue ? 'justify-between py-1' : 'py-2.5',
				error ? 'border-component-input-border-error' : 'border-component-input-border-default',
				!error && !disabled && 'hover:border-component-input-border-hover focus-within:border-component-input-border-typing!',
			)}>
				<input
					type="password"
					value={value}
					onChange={(e) => onChange(e.target.value)}
					placeholder={placeholder}
					disabled={disabled}
					className={clsx(
						'border-none outline-none flex-[1_0_0] text-sm',
						!hasValue && 'text-text-tertiary hover:text-text-secondary overflow-hidden overflow-ellipsis',
						disabled && 'text-text-tertiary',
					)}
				/>
			</div>
			{error && (
				<div className="flex items-start">
					<span className="text-component-input-text-supporting-text_error text-[11px]">{error}</span>
				</div>
			)}
		</div>
	);
};
